import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isImage',
  pure: true,
})
export class IsImagePipe implements PipeTransform {
  transform(mime: string | null | undefined): boolean {
    return !!mime && mime.startsWith('image/');
  }
}
